<template>
  <div>
    <!-- <YA_ScrollComponent :scrollHeight="55"> -->
      <PowerWriterMain ref="mainHeight" />

      <div>
        <PowerWriterContent />
      </div>

      <v-footer inset padless>
        <YA_footer />
      </v-footer>
    <!-- </YA_ScrollComponent> -->
  </div>
</template>

<script>
import YA_footer from '@/components/WebBar/YA_footer.vue';
import YA_ScrollComponent from '@/components/WebBar/YA_ScrollComponent.vue';
import PowerWriterMain from '@/components/PowerWriter/PowerWriterMain.vue';
import PowerWriterContent from '@/components/PowerWriter/PowerWriterContent.vue';

export default {
  name: 'PowerWriterView',
  components: {
    YA_footer,
    // YA_ScrollComponent,
    PowerWriterMain,
    PowerWriterContent
  },
  data() {
    return {

    }
  },
  created() {
    this.$store.watch(
      (state) => state.powerWriterMsg.powerWriterMainHeight, () => {
        if (this.$store.getters.getpowerWriterMainHeight) {
          window.scrollTo({
            top: this.$refs.mainHeight.$el.clientHeight,
            behavior: 'smooth',
          });
          this.$store.commit('HandlepowerWriterMainHeight', false);
        }
      }, {
        deep: true
      }
    );
  },
  mounted() {
    
  },
  methods: {
  }

};
</script>

<style scoped>

</style>